import DataStore from "../DataStore";
import {IJpInfoData} from "../../interface/IFooter";

export default class infoJP{
    private ds : DataStore

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        const infoData = this.getInfoData(this.ds.service);

        if(infoData){
            _wrapper.classList.add('footer-info-jp');
            _wrapper.innerHTML = this.templ(infoData);
        }
    }

    templ(_data: IJpInfoData){
        return `
        <div class="info-wrap">
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpTitle}</div>
                <div class="info-text">${_data.title}</div>
            </div>
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpGenre}</div>
                <div class="info-text">${_data.genre}</div>
            </div>
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpPrice}</div>
                <div class="info-text">${this.ds.l10n.infoJP.jpPriceValue}</div>
            </div>
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpOs}</div>
                <div class="info-text">${_data.os}</div>
            </div>
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpDevelopedBy}</div>
                <div class="info-text">NCSOFT</div>
            </div>
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpReleaseDay}</div>
                <div class="info-text">${_data.releaseDay}</div>
            </div>
        </div>
        `;
    }

    getInfoData(_service: string){
        if(_service === 'lineagew'){
            let resultInfoData : IJpInfoData = {
                title: 'リネージュ W',
                genre: 'MMORPG',
                os: 'iOS/Android/Windows',
                releaseDay: this.ds.l10n.infoJP.jpReleaseDayValue_LW
            }

            return resultInfoData;
        }
        if(_service === 'lineage2mncj'){
            let resultInfoData : IJpInfoData = {
                title: 'リネージュ2M',
                genre: 'MMORPG',
                os: 'iOS/Android/Windows',
                releaseDay: '2021年3月24日'
            }

            return resultInfoData;
        }
        return false;
    }
}